import {
    Button,
    Checkbox,
    Divider,
    Drawer,
    message,
    Modal,
    Select,
} from "antd";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { getTime } from "../../_helpers/app/dt";
import { getImageFileURL, getPublicImageURL } from "../../_helpers/image";
import {
    PREVIEW_CREATION_URL,
    PREVIEW_DOCUMENT_CREATION_URL,
    PREVIEW_DOCUMENT_TEMPLATE_URL,
    PREVIEW_TEMPLATE_URL,
} from "../../constants";
import RelationFieldStanard from "../../qforms/standard_elements/RelationFieldStandard";
import styles from "./styles/Preview.module.css";
import log from "cslog";
import { QurealViewer, useQurealActions } from "qureal-editor";

import {
    DownloadOutlined,
    ShareAltOutlined,
    SyncOutlined,
    ThunderboltOutlined,
    EyeOutlined,
    CloseOutlined,
    UploadOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import TemplateAIInput, {
    CustomizeDBInput,
    DBInput,
    getBlankFilledValues,
    removeUsedFields,
} from "./TemplateAIInput";
import {
    useAIImageGenerator,
    useGenerateTemplatePreset,
} from "../../_actions/bot";
import GenerationLoading from "./GenerationLoading";
import { getEditURL } from "../../_helpers/editor";
import LOGO from "../../media/imgs/1_logo_horizontal.png";
import LOGO_SQUARE from "../../media/imgs/0_logo_square.png";
import UserInputFormAll from "./UserInputForm";
import { useWindowSize } from "react-use";
import CommentsBox from "./CommentsBox";
import PublishTemplateModal from "./PublishTemplateModal";
import QurealViewerBox from "./QurealViewerBox";
import { useGeneratePresetDataWithAI } from "../../ai_img_gen/post_processing";
import { useTokens } from "../../_actions/finance";
import QurealOneViewer from "../../showwrapper/QurealOneViewer";
import GSBox from "./GSBox";
import { checkEnoughTokens } from "../../_actions/finance";
import BookAI from "./BookAI";
import ColorAITest from "./ColorAITest";
import { applyOGColor } from "./processors/designs";
import DesignCustomization from "./DesignCustomization";
import { useUpdateItemMutation } from "../../_actions/app/items";

const MODAL_HEIGHT = "90vh";

function PreviewTemplate({
    item,
    trigger,
    slug_field = "id",
    is_template = false,
    onRedeisgnClick = () => {},
    enable_redesign = false,
    open,
    setOpen,
    me = {},
    isMobile = false,
    post_idea = null,
    preset,
    default_values_for_publish = {},
}) {
    const [iopen, setIOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [prefill, setPrefill] = useState({});
    const { data: tokenData } = useTokens(me?.selected_org?.id);
    const [org, setOrg] = useState(me?.selected_org?.id);
    const [person, setPerson] = useState(null);
    const [preview, setPreview] = useState(true);
    const [status, setStatus] = useState({
        download: false,
        share: false,
    });

    const [bookPrefill, setBookPrefill] = useState([]);

    const [user_inputs, setUserInputs] = useState({
        enable: false,
        data: {},
    });
    const [user_prompt, setUserPrompt] = useState("");

    const [color_theme, setColorTheme] = useState(null);

    const { actionRef, download, share, updateOne } = useQurealActions();

    const { updateInputs, isLoading: loadingAIInput } =
        useGeneratePresetDataWithAI(setPrefill);

    const [user_inputs_filled, setUserInputsFilled] = useState({});

    const [gs_values, setGsValues] = useState({
        config: {},
    });
    const [gs_overrides, setGSOverrides] = useState({
        config: {},
    });

    // const [one, setOne] = useRef(null);
    const [one, setOne] = useState(null);

    console.log("token data in preview template", tokenData);
    useEffect(() => {
        if (iopen) {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [iopen]);

    useEffect(() => {
        if (item?.gconfig?.gconfig?.colors) {
            setGsValues({
                config: {
                    ...item?.gconfig?.gconfig?.colors,
                    ...item?.gconfig?.gconfig?.fontSets,
                },
            });
        }
    }, [item?.gconfig]);

    let url = `${is_template ? PREVIEW_TEMPLATE_URL : PREVIEW_CREATION_URL}${
        item[slug_field]
    }`;
    if (item?.type === "document") {
        url = `${
            is_template
                ? PREVIEW_DOCUMENT_TEMPLATE_URL
                : PREVIEW_DOCUMENT_CREATION_URL
        }${item[slug_field]}`;
    }

    const editor_url = `https://editor.qureal.com/${item?.id}/edit`;
    let customized = false;

    let iframe_url = `${url}?`;
    if (org) {
        iframe_url += `qi_organization=${org}`;
        customized = true;
    }
    if (person) {
        iframe_url += `&qi_person=${person}`;
        customized = true;
    }

    log.d(me, "Me in PreviewTemplate");
    log.d(item, "PreviewTemplate item");

    const onAISubmit = (data) => {
        // alert("submitting")
        const id_key = is_template ? "template_id" : "creation_id";
        const out = {
            ...data,
            [id_key]: item["id"],
        };
        log.d(out, "Submitting to AI");
        // mutationAIGen.mutate(out);
    };

    useEffect(() => {
        if (post_idea) {
            onAISubmit({
                user_prompt: post_idea,
            });
        }
    }, [post_idea, item]);

    // log.d(prefill, "Prefill now");
    log.d(item, "Item in PreviewTemplate");

    // ----------------------------------------------------------------------------
    const creation_type = item?.type;
    const inputs = item?.inputs || {};
    const page_id = creation_type === "document" ? "home" : "frontSide";

    const pageInputs = inputs?.[page_id];

    const design_theme = item?.theme;

    let db_inputs = {};
    if (pageInputs) {
        Object.keys(pageInputs).forEach((key) => {
            const input = pageInputs[key];
            if (input.block_type === "qureal_database") {
                db_inputs[key] = input;
            }
        });
    }
    // ----------------------------------------------------------------------------

    log.d(item, "item in PreviewTemplate");
    log.d(me?.selected_org, "selected_org in PreviewTemplate");
    const mutationUpdate = useUpdateItemMutation();
    const handleLive = (creationId) => {
        mutationUpdate.mutate(
            {
                collection: "qp_creation",
                id: creationId,
                data: {
                    is_live: true,
                },
            },
            {
                onSuccess: () => {
                    message.success("Creation went Live");
                },
                onError: (error) => {
                    message.error("Failed to live the creation");
                    console.error("Update error:", error);
                },
            },
        );
    };

    return (
        <Fragment>
            {trigger && (
                <span
                    onClick={(e) => {
                        e.preventDefault();
                        if (item?.type === "singlepage") {
                            setIOpen(true);
                        } else {
                            window.open(url, "_blank");
                        }
                    }}
                >
                    {trigger}
                </span>
            )}

            <PreviewWrapper
                trigger={trigger}
                open={open}
                setOpen={setOpen}
                iopen={iopen}
                setIOpen={setIOpen}
                isMobile={isMobile}
                // title={item.title}
                title={
                    <div className={styles.bottom_bar}>
                        <img
                            src={isMobile ? LOGO_SQUARE : LOGO}
                            className={styles.logo}
                        />

                        <div className={styles.bottom_bar_btn_group}>
                            <a href={url} target="_blank" rel="noreferrer">
                                {isMobile ? (
                                    <Button icon={<EyeOutlined />}></Button>
                                ) : (
                                    <Button icon={<EyeOutlined />}>
                                        Full page view
                                    </Button>
                                )}
                            </a>
                            <Button
                                onClick={download}
                                type="primary"
                                loading={status?.download}
                                icon={<DownloadOutlined />}
                            >
                                Download
                            </Button>
                            <Button
                                onClick={share}
                                type="primary"
                                loading={status?.share}
                                icon={<ShareAltOutlined />}
                            >
                                Share
                            </Button>
                        </div>
                    </div>
                }
            >
                <div className={styles.wrapper}>
                    <QurealViewerBox
                        item={item}
                        slug_field={slug_field}
                        preview={preview}
                        org={org}
                        person={person}
                        is_template={is_template}
                        prefill={prefill}
                        bookPrefill={bookPrefill}
                        isMobile={isMobile}
                        status={status}
                        setStatus={setStatus}
                        // loading={mutationAIGen?.isLoading}
                        url={url}
                        actionRef={actionRef}
                        download={download}
                        share={share}
                        gs_overrides={gs_overrides}
                        // gs_overrides={{
                        //     config: {
                        //         secondryColor: "hotpink"
                        //     }
                        // }}
                        onRender={(one) => {
                            log.d(one, "one in PTT");
                            setOne(one);
                        }}
                    />

                    <div className={styles.right_box}>
                        <div className={styles.top_pane}>
                            <div className={styles.action_wrapper}>
                                <Button
                                    icon={<SyncOutlined />}
                                    disabled={!enable_redesign}
                                    onClick={onRedeisgnClick}
                                >
                                    Redesign
                                </Button>
                                <Button
                                    icon={<ThunderboltOutlined />}
                                    disabled={
                                        Object.keys(user_inputs_filled)
                                            .length === 0
                                    }
                                    // loading={mutationAIGen.isLoading || loadingAIInput}
                                    loading={loadingAIInput}
                                    onClick={() => {
                                        updateInputs(user_inputs_filled);
                                    }}
                                >
                                    Rewrite
                                </Button>

                                {Object.keys(db_inputs).map((input_id) => {
                                    const input_data =
                                        db_inputs[input_id]?.data;
                                    const prefill_here = prefill?.[input_id];
                                    if (input_data?.used_fields?.length === 0) {
                                        return <></>;
                                    }
                                    return (
                                        <CustomizeDBInput
                                            input_id={input_id}
                                            used_fields={
                                                input_data?.used_fields
                                            }
                                            value={prefill_here?.exclude_fields}
                                            onChange={(new_values) => {
                                                log.d(input_id, "input_id");
                                                const new_prefill =
                                                    removeUsedFields(
                                                        prefill_here,
                                                        input_data?.used_fields,
                                                    );
                                                setPrefill({
                                                    ...prefill,
                                                    [input_id]: {
                                                        ...new_prefill,
                                                        exclude_fields:
                                                            new_values,
                                                        ...getBlankFilledValues(
                                                            new_values,
                                                        ),
                                                    },
                                                });
                                            }}
                                        />
                                    );
                                })}

                                {["designer", "reviewer"].includes(me?.irole) &&
                                    !is_template &&
                                    item?.templates?.length === 0 && (
                                        <PublishTemplateModal
                                            data={item}
                                            trigger={
                                                <Button
                                                    icon={<UploadOutlined />}
                                                >
                                                    Publish
                                                </Button>
                                            }
                                            onSuccess={() => {
                                                setOpen(false);
                                            }}
                                            default_values={
                                                default_values_for_publish
                                            }
                                        />
                                    )}
                            </div>

                            {!is_template && item?.templates?.length > 0 && (
                                <div style={{ marginTop: "10px" }}>
                                    <p style={{ color: "green" }}>
                                        Template published{" "}
                                        <a
                                            href={`https://show.qureal.com/ts/${item.templates[0]}`}
                                            target="_blank" rel="noreferrer"
                                        >
                                            here
                                        </a>
                                    </p>
                                </div>
                            )}
                            {me?.irole == "reviewer" &&
                                !is_template &&
                                item?.templates?.length > 0 &&
                                item?.is_live !== false && (
                                    <div>
                                        <p style={{ color: "green" }}>
                                            This Creation is Live
                                        </p>
                                    </div>
                                )}
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "10px",
                                }}
                            >
                                {!is_template &&
                                    item?.templates?.length > 0 && (
                                        <div style={{ marginTop: "10px" }}>
                                            <PublishTemplateModal
                                                data={item}
                                                trigger={
                                                    <Button
                                                        icon={<SyncOutlined />}
                                                    >
                                                        Sync Template
                                                    </Button>
                                                }
                                                onSuccess={() => {
                                                    setOpen(false);
                                                }}
                                                template_id={item?.templates[0]}
                                            />
                                        </div>
                                    )}
                                {me?.irole == "reviewer" &&
                                    !is_template &&
                                    item?.templates?.length > 0 &&
                                    item?.is_live !== true && (
                                        <div style={{ marginTop: "10px" }}>
                                            <Button
                                                onClick={() =>
                                                    handleLive(item?.id)
                                                }
                                                loading={
                                                    mutationUpdate.isLoading
                                                }
                                            >
                                                Go Live
                                            </Button>
                                        </div>
                                    )}

                                {["designer", "reviewer"].includes(
                                    me?.irole,
                                ) && (
                                    <div style={{ marginTop: "10px" }}>
                                        <Button
                                            key={item?.istatus}
                                            onClick={() => {
                                                mutationUpdate.mutate(
                                                    {
                                                        collection:
                                                            "qp_creation",
                                                        id: item?.id,
                                                        data: {
                                                            istatus:
                                                                item?.istatus ===
                                                                "idle"
                                                                    ? "ready"
                                                                    : "idle",
                                                        },
                                                    },
                                                    {
                                                        onSuccess: () => {
                                                            message.success(
                                                                "Creation marked as ready",
                                                            );
                                                        },
                                                        onError: (error) => {
                                                            message.error(
                                                                "Failed to mark creation as ready",
                                                            );
                                                        },
                                                    },
                                                );
                                            }}
                                            loading={mutationUpdate.isLoading}
                                        >
                                            Mark{" "}
                                            {item?.istatus === "idle"
                                                ? "Ready"
                                                : "Not Ready"}
                                        </Button>
                                    </div>
                                )}
                            </div>

                            {/* <Divider /> */}

                            <DesignCustomization
                                me={me}
                                item={item}
                                db_inputs={db_inputs}
                                isMobile={isMobile}
                                org={org}
                                setOrg={setOrg}
                                person={person}
                                setPerson={setPerson}
                                prefill={prefill}
                                setPrefill={setPrefill}
                                preset={preset}
                                gs_overrides={gs_overrides}
                                setGSOverrides={setGSOverrides}
                                bookPrefill={bookPrefill}
                                setBookPrefill={setBookPrefill}
                                loadingAIInput={loadingAIInput}
                                user_inputs={user_inputs}
                                tokenData={tokenData}
                                updateInputs={updateInputs}
                                slug_field={slug_field}
                                is_template={is_template}
                                // message={message}
                                setUserInputsFilled={setUserInputsFilled}
                                one={one}
                                updateOne={updateOne}
                                color_theme={color_theme}
                                setColorTheme={setColorTheme}
                            />

                            {/* {true &&
                                ["designer", "reviewer"].includes(me?.irole) &&
                                Object.keys(db_inputs).map((input_id) => {
                                    const input = db_inputs[input_id];
                                    return (
                                        <>
                                            <Divider />
                                            <DBInput
                                                record_id={item?.id}
                                                input_id={input_id}
                                                input_data={input?.data}
                                                me={me}
                                                isMobile={isMobile}
                                                org={org}
                                                onOrgChange={(val) =>
                                                    setOrg(val)
                                                }
                                                onOrgChangeFull={(org_full) => {
                                                    const brand_colors =
                                                        org_full?.brand_colors ||
                                                        {};
                                                    log.d(
                                                        brand_colors,
                                                        "brand_colors"
                                                    );
                                                    setGSOverrides({
                                                        config: brand_colors,
                                                    });
                                                }}
                                                person={person}
                                                onPersonChange={(val) =>
                                                    setPerson(val)
                                                }
                                                prefill={prefill?.[input_id]}
                                                setPrefill={(new_values) => {
                                                    setPrefill({
                                                        ...prefill,
                                                        [input_id]:
                                                            new_values || {},
                                                    });
                                                }}
                                                preset={preset}
                                            />
                                        </>
                                    );
                                })} */}

                            {/* <p>
                                is themeable: {item.is_themeable ? "yes" : "no"}
                            </p> */}

                            {/* {item?.is_themeable && ( */}
                            {/* {true && (
                                <GSBox
                                    initial_values={gs_values}
                                    values={gs_overrides}
                                    onChange={(new_values) => {
                                        setGSOverrides(new_values);
                                        setColorTheme(
                                            new_values?.config?.theme
                                        );

                                        const org_mod = getOrgMod(
                                            design_theme,
                                            new_values?.config?.theme,
                                            me?.selected_org
                                        );

                                        log.d(org_mod, "org_mod");
                                        setPrefill({
                                            ...prefill,
                                            current_organization: {
                                                ...org_mod,
                                            },
                                        });
                                    }}
                                    org={me?.selected_org}
                                />
                            )} */}

                            {/* {item?.type === "flipbook" && (
                                <div>
                                    <BookAI
                                        item={item}
                                        onBookGenerate={(val) => {
                                            setBookPrefill(val);
                                        }}
                                    />
                                </div>
                            )} */}

                            {/* <TemplateAIInput
                                record_id={item?.id}
                                inputs={item.inputs}
                                used_schemas={item.used_schemas}
                                me={me}
                                org={org}
                                creation_type={item.type}
                                onOrgChange={(val) => setOrg(val)}
                                person={person}
                                onPersonChange={(val) => setPerson(val)}
                                isMobile={isMobile}
                                loadingAI={loadingAIInput}
                                user_inputs={user_inputs}
                                prefill={prefill}
                                setPrefill={setPrefill}
                                slug={item[slug_field]}
                                is_template={is_template}
                                onSubmitInputs={(data) => {
                                    if (tokenData?.[0]?.count < 2) {
                                        console.log("token data", tokenData);
                                        message.error(
                                            "Not enough tokens to perform this generation"
                                        );
                                        return;
                                    }
                                    updateInputs(data);
                                    setUserInputsFilled(data);
                                }}
                            /> */}

                            {/* <pre>{JSON.stringify(prefill, null, 2)}</pre> */}

                            {/* {["designer", "reviewer"].includes(me?.irole) && (
                                <div
                                    style={{
                                        marginTop: "10px",
                                    }}
                                >
                                    <ColorAITest
                                        item={item}
                                        me={me}
                                        isMobile={isMobile}
                                        preset={preset}
                                    />
                                </div>
                            )} */}

                            {/* {["designer", "reviewer"].includes(me?.irole) && (
                                <div
                                    style={{
                                        marginTop: "10px",
                                    }}
                                >
                                    <Button
                                        onClick={() => {
                                            const newOne = applyOGColor(one);
                                            if (newOne) {
                                                updateOne(newOne);
                                            }
                                        }}
                                    >
                                        Apply OG Colors
                                    </Button>
                                </div>
                            )} */}

                            {!isMobile && (
                                <div
                                    style={{
                                        width: "100%",
                                        height: "200px",
                                        backgroundColor: "transparent",
                                    }}
                                ></div>
                            )}
                        </div>

                        <div className={styles.bottom_pane}>
                            {!is_template && <CommentsBox creation={item} />}
                        </div>
                    </div>
                </div>
            </PreviewWrapper>
        </Fragment>
    );
}

export default PreviewTemplate;

function PreviewWrapper({
    children,
    trigger,
    open,
    setOpen,
    iopen,
    setIOpen,
    isMobile,
    title,
}) {
    const { width, height } = useWindowSize();

    // useEffect(() => {
    //     const closeThis = () => setOpen(false);
    //     window.addEventListener("beforeunload", closeThis);
    //     return () => window.removeEventListener("beforeunload", closeThis);
    // }, [])

    if (isMobile) {
        return (
            <Drawer
                // title="Basic Drawer"
                // title={null}
                title={
                    <div className={styles.drawer_title_wrapper}>
                        {title}
                        {/* <span className={styles.drawer_close_btn} onClick={() => setOpen(false)}>X</span> */}
                        <div
                            onClick={() => setOpen(false)}
                            className={styles.drawer_close_btn_wrapper}
                        >
                            <Button icon={<CloseOutlined />}></Button>
                        </div>
                    </div>
                }
                placement="bottom"
                closable={false}
                onClose={() => setOpen(false)}
                open={open}
                key="qureal_preview_drawer"
                // size="large"
                // height="90vh"
                // height="100vh"
                height="100%"
                closeIcon={true}
                // getContainer={document.getElementById("preview_drawper_base")}
                // title={<div style={{
                //     width: "100%",
                //     height: "0px",
                //     margin: "-10px"
                // }} />}
            >
                {children}
            </Drawer>
        );
    }
    return (
        <Modal
            // title="Template Preview"
            open={trigger ? iopen : open}
            centered
            onOk={() => {
                setIOpen(false);
                if (!trigger) {
                    setOpen(false);
                }
            }}
            onCancel={() => {
                setIOpen(false);
                if (!trigger) {
                    setOpen(false);
                }
            }}
            // width={"75vw"}
            width={width > 1300 ? "1300px" : "98vw"}
            footer={null}
            style={{
                padding: "0px",
                // border: "2px dotted red"
            }}
        >
            {/* <h4>Width: {width}</h4> */}
            {children}
        </Modal>
    );
}

function isDictionary(value) {
    return (
        value !== null &&
        typeof value === "object" &&
        value.constructor === Object
    );
}
